import CorrectionType from "./actionTypes"



// function that called as action
const getListPage = data => ({
  type: CorrectionType.GET_CORRECTION_PAGES,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListPageSuccess = data => ({
  type: CorrectionType.GET_CORRECTION_PAGES_SUCCESS,
  payload: data,
})

// function that called as action
const getDetail = (data, action) => ({
  type: CorrectionType.GET_DETAIL_CORRECTION_BY_ID,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const getDetailSuccess = data => ({
  type: CorrectionType.GET_DETAIL_CORRECTION_BY_ID_SUCCESS,
  payload: data,
})

// function that called as action
const postData = (data, action) => ({
  type: CorrectionType.POST_CORRECTION,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const postDataSuccess = data => ({
  type: CorrectionType.POST_CORRECTION_SUCCESS,
  payload: data,
})

// function that called as action
const putData = (data, action) => {
  return {
    type: CorrectionType.PUT_CORRECTION,
    payload: data,
    action
  }
}

// function to update state in reducer when fetching api is succeed or failed
const putDataSuccess = data => ({
  type: CorrectionType.PUT_CORRECTION_SUCCESS,
  payload: data,
})


// function that called as action
const getList = data => ({
  type: CorrectionType.GET_CORRECTION_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListSuccess = data => ({
  type: CorrectionType.GET_CORRECTION_LIST_SUCCESS,
  payload: data,
})


const CorrectionAction = {
  getListPage,
  getListPageSuccess,


  getDetail,
  getDetailSuccess,


  postData,
  postDataSuccess,

  putData,
  putDataSuccess,

  getList,
  getListSuccess,

}

export default CorrectionAction





